module.exports = __webpack_public_path__ + "img/8.52df0513.jpg";